import { ICreateObraAreaChecklistUseCase } from "../../../presentation/useCases/create/create_obra_area_checklist_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateObraAreaChecklistUseCase
 */

export class CreateObraAreaChecklistUseCase implements ICreateObraAreaChecklistUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createObraAreaChecklist(
    idObra: number,
    status: number,
    area: string,
    checklists: number[] | null,
  ): Promise<void> {
    await this.repository.createObraAreaChecklist(
      idObra,
      status,
      area,
      checklists,
    )
  }
}
